/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */
export enum DriverInfoDeviceType {
    Tachograph = 'tachograph',
    HwDevice = 'hw_device',
    ApiId = 'api_id',
    DefaultDriver = 'default_driver',
    Manual = 'manual'
}

export function DriverInfoDeviceTypeFromJSON(json: any): DriverInfoDeviceType {
    return DriverInfoDeviceTypeFromJSONTyped(json, false);
}

export function DriverInfoDeviceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DriverInfoDeviceType {
    return json as DriverInfoDeviceType;
}

export function DriverInfoDeviceTypeToJSON(value?: DriverInfoDeviceType | null): any {
    return value as any;
}

